import React from 'react'
import { Link } from 'react-router-dom'
import { Button, Col, Row } from 'reactstrap'

const BloodTestImportance = () => {
  return (
    <div id='website-responsive'>
        <div className='bg-img left-padding5rem1 right-padding5rem1 p-top-bottom2rem' style={{ backgroundImage:'url("https://unitedlabcare.com/wp-content/uploads/2022/12/ULC-Testing-bg-v1.png")', height:'100%', width:'100%'}}>
            <Row className='py py-md-4 py-lg-0'>
                <Col md='12' lg='6' className=''>
                    <div className=''>
                        <div className=''>
                            <h2 className='fw-700 text-ss-primary'>
                                Importance of Blood Test Results
                            </h2>
                            <hr className='hr-style my-md-2' style={{ width:'80px', marginTop:'2px', marginBottom:'4px'}}/>
                        </div>

                        <div className='py-3'>
                            <p className='lh-1-6'>
                            Abnormal blood test results do not necessarily indicate a serious medical condition. They merely reflect changes occurring in your body. Healthcare providers use these results as a starting point for further investigations. They can obtain a more detailed view of your health status by conducting more tests. Remember that phlebotomists are trained to collect blood samples efficiently and with minimal discomfort, ensuring a smooth testing experience. 
                            </p>
                        </div>

                        <div className='flex-center1'>
                        <Link to='/general-blood-test-appointment' >
                            <Button className='btn-ss-secondary rounded20 ' style={{  boxShadow:'1px 1px 6px 0 rgba(0,0,0,.4)'}}>
                                <text className='text-montserrat fw-600 fs-ss-16' style={{ padding:'10px 10px',}}>
                                    Get Tested Today
                                </text>
                            </Button>
                        </Link>
                        </div>
                    </div>
                </Col>

                <Col md='12' lg='6' className='mt-4'>
                    <div className='flex-center mt-md-0 mt-5'>
                        <img className='img-w16' src='https://unitedlabcare.com/wp-content/uploads/2023/06/Blood-Testing-img1-v1.png' alt='pic' height='auto' />
                    </div>
                </Col>
            </Row>
        </div>
    </div>
  )
}

export default BloodTestImportance